import { useNavigate } from "react-router-dom";
import LogoSVG from "./LogoSVG";
import { ORG } from "../data/initialData";

export default function Footer() {
  const navigate = useNavigate();
  const go = path => { navigate(path); window.scrollTo({ top: 0, behavior: "smooth" }); };

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div style={{ marginBottom: ".75rem" }}><LogoSVG size={56} inv/></div>
          <div className="fb1">Lomban Hydropower Development Association Inc.</div>
          <div className="fb2">
            Inc. No. 5-105293<br/>
            Wabag District, Enga Province<br/>
            Papua New Guinea<br/><br/>
            Kaiyaul (Awain Tribe) &amp; Piau (Yanaitin Tribe)<br/>
            Lomban Falls, Lai River
          </div>
        </div>

        <div className="footer-col">
          <h4>Navigation</h4>
          {[
            ["/",        "Home"],
            ["/about",   "About LHDA"],
            ["/news",    "News & Announcements"],
            ["/projects",   "Projects"],
            ["/landowners", "Members"],
            ["/contact",    "Contact"],
          ].map(([path, label]) => (
            <button key={path} className="f-lnk" onClick={() => go(path)}>{label}</button>
          ))}
        </div>

        <div className="footer-col">
          <h4>About the Project</h4>
          <div style={{ color: "rgba(255,255,255,.55)", fontSize: ".82rem", lineHeight: 1.8 }}>
            <div>⚡ Lomban Hydropower Project</div>
            <div>📍 Lomban Falls, Lai River, Wabag</div>
            <div>🗺️ Portion 882C — 14.61 ha</div>
            <div>🏛️ Trustee: Lomban Hydropower Limited</div>
            <div>⚖️ Incorporated under Associations Act 2023</div>
          </div>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <div style={{ color: "rgba(255,255,255,.6)", fontSize: ".82rem", lineHeight: 1.8 }}>
            <div>📍 Wabag District, Enga Province, PNG</div>
            <div>✉️ <a href={`mailto:${ORG.email}`} style={{ color: "rgba(255,255,255,.6)" }}>{ORG.email}</a></div>
            <div>👤 {ORG.lhlmd}</div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Lomban Hydropower Development Association Inc. (LHDA). Inc. No. 5-105293.</span>
        <span>Wabag District, Enga Province, Papua New Guinea</span>
      </div>
    </footer>
  );
}
